/* Pipsqueak motion — scroll reveals + subtle hero parallax.
   Vanilla JS. Respects prefers-reduced-motion. Defers all work until DOM ready.
   Uses IntersectionObserver (broadly supported) and rAF-throttled scroll. */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    if (prefersReducedMotion) return;

    // ---------- Scroll reveal on Pipsqueak sections ----------
    var revealCandidates = document.querySelectorAll(
      '[class*="shopify-section--pip-"], .pip-reveal'
    );
    if (!revealCandidates.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      revealCandidates.forEach(function (el) {
        el.classList.add('pip-reveal--in');
      });
    } else {
      revealCandidates.forEach(function (el) {
        el.classList.add('pip-reveal');
      });

      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('pip-reveal--in');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -64px 0px' }
      );

      revealCandidates.forEach(function (el) {
        revealObserver.observe(el);
      });
    }

    // ---------- Hero subtle parallax ----------
    var heroVisual = document.querySelector('.pip-hero__visual');
    if (!heroVisual) return;

    var ticking = false;
    function updateParallax() {
      var rect = heroVisual.getBoundingClientRect();
      // negative scroll position drift, capped at 0..40px
      var raw = rect.top * -0.12;
      var offset = Math.max(0, Math.min(40, raw));
      heroVisual.style.setProperty('--pip-hero-parallax', '-' + offset + 'px');
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      },
      { passive: true }
    );

    updateParallax();
  }

  function initQuickview() {
    var modal = document.getElementById('pip-quickview-modal');
    if (!modal || typeof modal.showModal !== 'function') return;

    var modalImage = modal.querySelector('.pip-quickview__image');
    var modalTitle = modal.querySelector('.pip-quickview__title');
    var modalPrice = modal.querySelector('.pip-quickview__price');
    var modalLink = modal.querySelector('.pip-quickview__link');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-pip-quickview]');
      if (trigger) {
        e.preventDefault();
        var d = trigger.dataset;
        if (modalImage) {
          modalImage.src = d.productImage || '';
          modalImage.alt = d.productTitle || '';
        }
        if (modalTitle) modalTitle.textContent = d.productTitle || '';
        if (modalPrice) modalPrice.innerHTML = d.productPrice || '';
        if (modalLink) modalLink.href = d.productUrl || '#';
        modal.showModal();
        return;
      }

      var closeBtn = e.target.closest('[data-pip-quickview-close]');
      if (closeBtn) {
        modal.close();
        return;
      }

      // Click backdrop (clicked on dialog itself, not its inner content) closes.
      if (e.target === modal) {
        modal.close();
      }
    });
  }

  function bootAll() {
    init();
    initQuickview();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }
})();
